import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/')({
  loader: async ({ context }) => {
    const { organizationName } = context;
    if (!organizationName) {
      throw redirect({ to: '/' });
    }
    throw redirect({
      to: '/org/$org',
      params: { org: organizationName },
    });
  },
});
